// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Back',
    title: 'Role Claims',
    role: 'Role',
    save: 'Save',
}
